import React, { useState } from 'react';
import WellInfo from './WellInfo/index';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { IStyle } from 'Styles';
import WellIngredientsScores from './WellIngredientScores';
import { DEFAULT_FIND_DROP_WIDTH } from 'components/sidePanel/experiment/Constants';

export interface FindDropProps {
  setPanelWidth: React.Dispatch<React.SetStateAction<number>>;
}

const EXTENDED_SIDE_PANEL_WIDTH = 40;

const FindDrop = (props: FindDropProps) => {
  const { setPanelWidth } = props;
  const [showScoresPanel, setShowScoresPanel] = useState(false);

  const toggleIngredientsScorePanel = () => {
    setPanelWidth(showScoresPanel ? DEFAULT_FIND_DROP_WIDTH : EXTENDED_SIDE_PANEL_WIDTH);
    setShowScoresPanel(!showScoresPanel);
  };
  return (
    <>
      <div
        id='finddrop-wrapper'
        style={
          showScoresPanel ? styles.wellInfoStyleWithScoresPanel : styles.wellInfoStyle
        }
      >
        <div id='finddrop-header' style={styles.header}>
          <div id='finddrop-header-leftsection' style={styles.leftHeaderSection}>
            <div id='finddrop-header-left-title' style={styles.headerInfoContent} title={'Find Drops'}>
              {' '}
              {'Find Drops'}{' '}
            </div>
          </div>
          <div id='finddrop-header-rightsection' style={styles.rightHeaderSection}> </div>
          <RMCustomButton
            iconProps={{
              id:'finddrop-filter-button',
              name: 'Filter',
              width: '44px',
              height: '30px',
              fill: 'transparent',
            }}
            contentContainerStyle={styles.filterButton}
            onClick={toggleIngredientsScorePanel}
          />
        </div>
        <WellInfo id='finddrop-wellinfo-component'/>
      </div>
      <div
        id='finddrop-scorespanel-wrapper'
        style={
          showScoresPanel
            ? styles.wellIngredientsScoresVisible
            : styles.wellInfoScoresHidden
        }
      >
        <WellIngredientsScores />
      </div>
    </>
  );
};

const styles: IStyle = {
  header: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    minHeight: '7vh',
    backgroundColor: '#F5F5F5',

    alignItems: 'center',
  },
  leftHeaderSection: {
    marginLeft: '1.5%',
    display: 'flex',
    gap: '1%',
  },
  headerInfoContent: {
    fontWeight: 600,
    textOverflow: 'ellipsis',
    overflow: 'clip',
    marginBlock: 'auto',
  },
  rightHeaderSection: {
    marginRight: '4%',
    display: 'flex',
    gap: '10%',
  },
  filterButton: {
    position: 'absolute',
    right: '3%',
  },
  wellInfoStyle: {
    width: '100%',
  },
  wellInfoStyleWithScoresPanel: {
    position: 'absolute',
    right: '0%',
    width: '62%',
  },
  wellIngredientsScoresVisible: {
    display: 'block',
    position: 'relative',
    maxWidth: '38%',
    border: '1px solid lightgray',
  },
  wellInfoScoresHidden: {
    display: 'none',
  },
};

export default FindDrop;
